import React from 'react'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { VB_CATEGORY_SETTINGS, VB_FEATURED_CATEGORIES } from '../../CustomElements/elementTypes'
import SingleBrandProductList from '../../Core/ListComponents/SingleBrandProductList'
import StandardCategoryBanner from '../../Core/Banners/StandardCategoryBanner'
import { FeatureCategoriesCarousel } from '../../Core/Carousels/FeatureCategoriesCarousel'
import { useIntl } from '@jetshop/intl'

const BrandSingle = ({ category, parents }) => {
   const t = useIntl()
   const isSingleBrand = true
   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)
   const featuredCategoryItems =
      category?.data?.items?.find(c => c?.type == VB_FEATURED_CATEGORIES)?.children ?? []
   const featuredCategoriesTitle = t('popular_categories') || 'Populära kategorier'

   return (
      <>
         <StandardCategoryBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
            isSingleBrand={isSingleBrand}
         ></StandardCategoryBanner>
         <FeatureCategoriesCarousel
            categories={featuredCategoryItems}
            title={featuredCategoriesTitle}
         />
         <SingleBrandProductList category={category}></SingleBrandProductList>
         {/* <StandardCategoryFooter category={category} categorySettings={categorySettings}></StandardCategoryFooter> */}
         <RenderCustomElements items={items}></RenderCustomElements>
      </>
   )
}

export default BrandSingle
